import * as Actions from '../../actions/problems/type';

const initialState = {
  addedProblem: {},
  updatedProblem: {},
  deletedProblem: {},
  addConcernLoader: false,
  addTechRecomendationLoader: false,
  updateConcernLoader: false,
  updateTechRecomendation: false,
  deleteConcernLoader: false,
  deleteTechRecomendation: false,
  addProblemErr: '',
  updateProblemErr: '',
  deleteProblemErr: '',
};

export const ProblemReducer = (state = initialState, action) => {
  switch (action.type) {
    // Generate RO
    // add problem
    case Actions.ADD_PROBLEM_REQUEST:
      return {
        ...state,
        addConcernLoader:
          action?.problemType === 'customerConcern' ? true : false,
        addTechRecomendationLoader:
          action?.problemType === 'techRecommendation' ? true : false,
      };
    case Actions.ADD_PROBLEM_SUCCESS:
      return {
        ...state,
        addConcernLoader: false,
        addTechRecomendationLoader: false,
        addedProblem: action?.payload?.data || {},
      };
    case Actions.ADD_PROBLEM_FAIL:
      return {
        ...state,
        addConcernLoader: false,
        addTechRecomendationLoader: false,
        addProblemErr: action.payload,
      };

    case Actions.UPDATE_PROBLEM_REQUEST:
      return {
        ...state,
        updateConcernLoader:
          action?.problemType === 'customerConcern' ? true : false,
        updateTechRecomendation:
          action?.problemType === 'techRecommendation' ? true : false,
      };
    case Actions.UPDATE_PROBLEM_SUCCESS:
      return {
        ...state,
        updateConcernLoader: false,
        updateTechRecomendation: false,
        updatedProblem: action?.payload?.data || {},
      };
    case Actions.UPDATE_PROBLEM_FAIL:
      return {
        ...state,
        updateConcernLoader: false,
        updateTechRecomendation: false,
        updateProblemErr: action.payload,
      };
    case Actions.DELETE_PROBLEM_REQUEST:
      return {
        ...state,
        deleteConcernLoader:
          action?.problemType === 'customerConcern' ? true : false,
        deleteTechRecomendation:
          action?.problemType === 'techRecommendation' ? true : false,
      };
    case Actions.DELETE_PROBLEM_SUCCESS:
      return {
        ...state,
        deleteConcernLoader: false,
        deleteTechRecomendation: false,
        deletedProblem: action?.payload?.data || {},
      };
    case Actions.DELETE_PROBLEM_FAIL:
      return {
        ...state,
        deleteConcernLoader: false,
        deleteTechRecomendation: false,
        deleteProblemErr: action.payload,
      };
    case Actions.CLEAR_PROBLEM_STATS:
      return {
        ...state,
        addedProblem: {},
        updatedProblem: {},
        deletedProblem: {},
        addProblemErr: '',
        updateProblemErr: '',
        deleteProblemErr: '',
      };
    default:
      return state;
  }
};
